/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { makeStyles } from '@mui/styles';

export const useSetupLayoutStyles = makeStyles(() => ({
  root: {
    minWidth: '100vw',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  heading: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoWrap: {
    width: '217px',
    height: '95px',
    padding: '25px',
  },
  logo: {
    width: '100%',
    height: '100%',
  },
  lang: {
    position: 'absolute',
    right: '50px',
  },
  children: {
    padding: '0 150px',
    '@media (max-width: 1000px)': {
      padding: '0 75px',
    },
    '@media (max-width: 750px)': {
      padding: '0',
    },
    flex: 1,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
}));
